import { configureStore, combineReducers } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import projectReducer from './projectSlice';
import userReducer from './userSlice';
import spaceReducer from './spaceSlice';
import ticketReducer from './ticketSlice';
import calendarReducer from './calendarSlice';
import timesheetReducer from './timesheetSlice';
import promptTemplateReducer from './promptTemplateSlice';
import aiDevReducer from './aiDevSlice';
import reportReducer from './reportSlice';
import strategistReducer from './strategistSlice';
import uiReducer from './uiSlice';
import alertReducer from './alertSlice';
import notificationReducer from './notificationSlice';
import slackReducer from './slackSlice';
import scrumReducer from './scrumSlice';
import dailyStandupReducer from './dailyStandupSlice';

const appReducer = combineReducers({
  auth: authReducer,
  projects: projectReducer,
  users: userReducer,
  spaces: spaceReducer,
  tickets: ticketReducer,
  calendar: calendarReducer,
  timesheet: timesheetReducer,
  promptTemplates: promptTemplateReducer,
  aiDev: aiDevReducer,
  report: reportReducer,
  strategist: strategistReducer,
  ui: uiReducer,
  alerts: alertReducer,
  notifications: notificationReducer,
  slack: slackReducer,
  scrum: scrumReducer,
  dailyStandup: dailyStandupReducer,
});

const rootReducer = (state, action) => {
  if (action.type === 'auth/logout') {
    state = undefined;
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
});
